export class ClickOutside {
  static addClickOutside(parents: HTMLElement[], callback: Function) {
    document.addEventListener('click', (event: MouseEvent) => {
      let clickOutside: boolean = true;
      parents.forEach((element: HTMLElement) => {
        if (element.contains(event.target as HTMLElement)) {
          clickOutside = false;
        }
      });
      if (clickOutside === true) {
        callback();
      }
    });
  }
}
